import { render, staticRenderFns } from "./approval-document-details.vue?vue&type=template&id=2025aad7&scoped=true&"
import script from "./js/approval-document-details.js?vue&type=script&lang=js&"
export * from "./js/approval-document-details.js?vue&type=script&lang=js&"
import style0 from "./approval-document-details.vue?vue&type=style&index=0&id=2025aad7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2025aad7",
  null
  
)

export default component.exports